import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-collectibles',
  templateUrl: 'collectibles.html'
})
export class CollectiblesPage {
  collectibles:any;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);

    //TODO generalize collectibles in object
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/collectibles/collectibles.ts